import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import Button from "@atoms/button"
import { useCookies } from "react-cookie";

const StyledContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 1rem;
  left: 0;
  right: 0;
  align-items: baseline;
  justify-content: center;
  padding: 0 1rem;
  z-index: 500;
`

const StyledButton = styled(Button)`
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  font-size: 1rem;
`

const StyledBanner = styled.div`
  display: flex;
  flex: 1;
  background: #181C26;
  color: white;
  padding: 1rem 1.25rem 1rem 2rem;
  max-width: 1280px;
  align-items: center;
  gap: 1rem;
  border-radius: 3rem;
  box-shadow: 0px 4px 24px rgba(0,0,0,0.1);
`

const StyledText = styled.p`
  margin: 0;
  flex: 1;
`

const ACCEPT_CONSENT = {
  adConsentGranted: true,
  analyticsConsentGranted: true,
  functionalityConsentGranted: true,
  personalizationConsentGranted: true,
  securityConsentGranted: true,
}

const REJECT_CONSENT = {
  adConsentGranted: false,
  analyticsConsentGranted: false,
  functionalityConsentGranted: false,
  personalizationConsentGranted: false,
  securityConsentGranted: false,
}

const COOKIE_CONSENT = 'metrichq_consent'

const Consent = () => {

  const consentListeners = useRef(null);
  const [isInit, setIsInit] = useState(false);
  const [cookies, setCookie] = useCookies([COOKIE_CONSENT])
  const consentSettings = useMemo(() => cookies[COOKIE_CONSENT], [cookies])

  useEffect(() => {
    if(consentListeners.current === null && window.consentListeners.length > 0) {
      consentListeners.current = window.consentListeners
      setIsInit(true)
    }
  }, [consentListeners, setIsInit])

  const accept = useCallback(() => {
    consentListeners.current.forEach((callback) => {
      callback(ACCEPT_CONSENT)
    })
    setCookie(COOKIE_CONSENT, ACCEPT_CONSENT)

  }, [consentListeners])

  const reject = useCallback(() => {
    consentListeners.current.forEach((callback) => {
      callback(REJECT_CONSENT)
    })
    setCookie(COOKIE_CONSENT, REJECT_CONSENT)

  }, [consentListeners])

  if(consentSettings !== undefined || !isInit) {
    return null
  }

  return <StyledContainer>
    <StyledBanner>
      <StyledText>We use third-party analytics cookies to understand how you use our website so we can build better products.</StyledText>
      <StyledButton onClick={accept}>Accept</StyledButton>
      <StyledButton onClick={reject}>Reject</StyledButton>
    </StyledBanner>
  </StyledContainer>
}


export default Consent;
